export {
  default as homeGym,
  ReactComponent as HomeGym,
} from '@assets/icons/use-cases/home-gym.svg'    
